// Auto-generated build version — updated by post-build.cjs
export const BUILD_VERSION = "08.09.2026, 11:32:53";
export const BUILD_TIMESTAMP = "2026-09-08T08:32:53.875Z";
